export const defineValue = (...text: string[]) => {
  return text.join().replaceAll(/\s/g, '').toLowerCase();
};
